import React from 'react'
import PropTypes from 'prop-types'
import OrganisationLogo from './OrganisationLogo'

const LinkedOrganisationLogo = ({ linkPrefix, slug, shortname, logo_url, className }) => {
  const link = linkPrefix + slug
  return (
    <React.Fragment>
      <a href={link}
         title={shortname + ' Organisations-Profil'}
         className={`d-block ${className || ''}`}>
        <OrganisationLogo
          logo_url={logo_url}
          shortname={shortname}
        />
      </a>
    </React.Fragment>
  )
}

LinkedOrganisationLogo.propTypes = {
  slug: PropTypes.string.isRequired,
  shortname: PropTypes.string.isRequired,
  linkPrefix: PropTypes.string.isRequired,
  logo_url: PropTypes.string.isRequired
}

export default LinkedOrganisationLogo
